import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { TypedMemo } from '../../common/types';
import { BillingInterval } from '../config/music24StripePlans';
import { BillingToggle } from '../components/SMLPricing/components/BillingToggle';
import { useIsNativeEmbed } from '../navigation/hooks/useIsNativeEmbed';
import { PlansRefundLine } from './PlansRefundLine';
import styles from './PlansHead.module.scss';

const messages = defineMessages({
  back: { id: 'app.buttons.back', defaultMessage: 'Back' },
  title: { id: 'app.sml.plans.page.title', defaultMessage: 'Plans' },
  // The native apps read this id too (scripts/music24-native/i18n-keys.txt).
  sub: {
    id: 'app.sml.pricing.plans.sub',
    defaultMessage: 'Start on Free and keep it. Upgrade when you need more pitches, videos or history.',
  },
});

interface PlansHeadProps {
  interval: BillingInterval;
  onIntervalChange: (interval: BillingInterval) => void;
  onBack: () => void;
}

/**
 * The head of the plans page (design plans-page a): Back on the left, the billing switch on the
 * right, then the title and the refund line. Inside a native app's web view there is no web price,
 * so the switch and the refund line are not shown (App Store 3.1.1, Play billing).
 */
const PlansHeadComponent: React.FC<PlansHeadProps> = ({ interval, onIntervalChange, onBack }) => {
  const intl = useIntl();
  const isNativeEmbed = useIsNativeEmbed();

  return (
    <div className={styles.head}>
      <div className={styles.topRow}>
        <button type="button" className={styles.back} onClick={onBack}>
          <FontAwesomeIcon icon={faArrowLeft} />
          {intl.formatMessage(messages.back)}
        </button>
        {!isNativeEmbed && <BillingToggle className={styles.toggle} interval={interval} onChange={onIntervalChange} />}
      </div>
      <div className={styles.hero}>
        <div>
          <h1 className={styles.title}>{intl.formatMessage(messages.title)}</h1>
          <p className={styles.sub}>{intl.formatMessage(messages.sub)}</p>
        </div>
        {!isNativeEmbed && <PlansRefundLine className={styles.assure} />}
      </div>
    </div>
  );
};

export const PlansHead = TypedMemo(PlansHeadComponent);
